import axios from 'axios'
import store from '@/store'
import secret from './secret'
import router from '@/router'
import { getToken, removeUserToken } from '@/utils/cookies'
// import { removeLocalOrderProsData, removeLocalOrderNumData } from '@/utils/storage'
const JGSSO_WEB_URL = process.env.JGSSO_WEB_URL

const defauleTimeOut = 1000 * 10
const axiosService = axios.create({
  timeout: defauleTimeOut
})
axiosService.defaults.baseURL = 'api'
axiosService.defaults.withCredentials = true
axiosService.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'

// let yToken = {"appCode":"bdks","plat":"pc","time":"2020-11-03T18:32:31","userToken":"dsdsdsdsdsadasds"}
// let secretData =  secret.encrypt(JSON.stringify(yToken),'dsdsdsdsdsadasds') ;
// console.log('secretData',secretData)

// http request 拦截器
axiosService.interceptors.request.use(
  config => {
    let xtoken = getToken()
    console.log("jgs_xtoken", xtoken)
    xtoken = (xtoken === 'undefined' || xtoken == null) ? '' : xtoken
    console.log(xtoken)
    if (xtoken !== '') {
      function time(time = +new Date()) {
        var date = new Date(time + 8 * 3600 * 1000); // 增加8小时
        return date.toJSON().substr(0, 19).replace('T', ' ');
      }
      console.log(time())
      let yToken = {"appCode":"gzgw","plat":"pc","time":time(+new Date()),"userToken":xtoken}
      let accessToken =  secret.encrypt(JSON.stringify(yToken),xtoken.slice(0,16)) ;
      console.log('jgsaccessToken',accessToken)
      config.headers['token'] = xtoken
      config.headers['accessToken'] = accessToken
    }

    xtoken = (xtoken === 'undefined') ? '' : xtoken
    console.log('xtoken',xtoken)
    if (config.method === 'post') {
      config.params = {
        token: xtoken,
        ...config.params
      }
    } else if (config.method === 'get') {
      config.params = {
        token: xtoken,
        ...config.params
      }
    }
    console.log(config);
    
    return config
  },
  err => {
    console.log(err)
    return Promise.reject(err)
  })

// respone拦截器
axiosService.interceptors.response.use(
  response => {

    // console.log("9999response",response)
    if (response.data == null && response.config.responseType === 'json' && response.request.responseText != null) {
      try {
        // eslint-disable-next-line no-param-reassign
        response.data = JSON.parse(response.request.responseText);
      } catch (e) {
        // ignored
      }
    }
    const resData = response.data
    const thisRequest = response.request 
    // console.log(" response.request ",thisRequest.responseURL.indexOf('/zauser/findZaUserByToken') );
   
    const errorInfo = resData.errorInfo
    if (errorInfo === 'tokenInvalid') {
      store.dispatch('FedLogOut').then(res => {
        window.location.reload()
      }).catch(() => {
      })
    } else if (errorInfo === 'notLogin') {
      // console.log('99999',isLogin, loginToken)
    } else if (errorInfo === 'notAuthor') {
      console.log("999test",thisRequest.responseURL)
      if(thisRequest.responseURL){
        if (thisRequest.responseURL.indexOf("/zauser/findZaUserByToken") > 0 || thisRequest.responseURL.indexOf("/shoppingCart/web/pageShoppingCart") > 0 ) {
          // console.log("thisRequest",thisRequest);
        }
        else {
          // removeUserToken()
        //   window.location.href = JGSSO_WEB_URL
          console.log("跳转111")
        }
      }else{
        // window.location.href = JGSSO_WEB_URL
        console.log("跳转222")
      }
    }
    return response
  },
  error => { // 默认除了2XX之外的都是错误的，就会走这里
    if (error.response) {
      switch (error.response.status) {
        case 401:
          if (store.state.gameId) {
            /* store.commit('DELETE_TOKEN'  )
            router.replace({ // 跳转到登录页面
              path: '/login?gameId=' + store.state.gameId,
              query: {redirect: router.currentRoute.fullPath, gameId: store.state.gameId} // 将跳转的路由path作为参数，登录成功后跳转到该路由
            }) */
          } else {
            // store.commit('USER_LOGOUT')
          }
      }
    }
    return Promise.reject(error.response)
  }
)

export default axiosService



// WEBPACK FOOTER //
// ./src/utils/request.js